import React from 'react'

const CallCenter = props => (
  <svg width={24} height={24} {...props}>
    <defs>
      <path
        id="call-center_svg__a"
        d="M19.5 14.5a.834.834 0 01-.833-.833V12a.833.833 0 011.666 0v1.667a.834.834 0 01-.833.833m-15-3.333c.46 0 .833.374.833.833v1.667a.834.834 0 01-1.666 0V12c0-.46.373-.833.833-.833M12 2C6.478 2 2 6.478 2 12v1.667a2.5 2.5 0 005 0V12a2.5 2.5 0 00-2.5-2.5c-.158 0-.313.018-.464.047 1.05-3.401 4.223-5.88 7.964-5.88 3.74 0 6.914 2.479 7.964 5.88A2.45 2.45 0 0019.5 9.5 2.5 2.5 0 0017 12v1.667a2.5 2.5 0 002.5 2.5c.163 0 .322-.019.475-.049a5.627 5.627 0 01-.738 1.38c-.515.701-1.264 1.394-2.411 1.93-1.147.532-2.703.905-4.826.905A.834.834 0 0012 22c2.39 0 4.242-.436 5.663-1.125 2.137-1.032 3.254-2.633 3.79-3.948.542-1.318.545-2.356.547-2.427V12c0-5.522-4.477-10-10-10"
      />
    </defs>
    <use xlinkHref="#call-center_svg__a" />
  </svg>
)

export default CallCenter
